import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dd19ccba")

_pushScopeId("data-v-dd19ccba")
const _hoisted_1 = { class: "mobile-menu" }
const _hoisted_2 = {
  key: 0,
  class: "mobile-menu-wrap"
}
const _hoisted_3 = { class: "btn-cancel-slot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MenuSettingsItem = _resolveComponent("MenuSettingsItem")
  const _component_EmojiPanel = _resolveComponent("EmojiPanel")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isMenu)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.modes[_ctx.mode] === _ctx.modes.default)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.listMenuDefault, (item) => {
                return (_openBlock(), _createBlock(_component_MenuSettingsItem, {
                  icon: item.icon,
                  title: item.title,
                  isDisabled: item.isDisabled,
                  onClick: ($event: any) => (_ctx.changeStatus(item.type))
                }, null, 8, ["icon", "title", "isDisabled", "onClick"]))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.modes[_ctx.mode] === _ctx.modes.admin)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.listMenuAdmin, (item) => {
                return (_openBlock(), _createBlock(_component_MenuSettingsItem, {
                  icon: item.icon,
                  title: item.title,
                  isDisabled: item.isDisabled,
                  isActivated: item.isActivated,
                  onClick: ($event: any) => (_ctx.changeStatus(item.type))
                }, null, 8, ["icon", "title", "isDisabled", "isActivated", "onClick"]))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.modes[_ctx.mode] !== _ctx.modes.default)
            ? (_openBlock(), _createBlock(_component_EmojiPanel, {
                key: 2,
                class: "emojis"
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              class: "btn-cancel",
              size: "l",
              mode: "outlined",
              onClick: _ctx.closeDrawer
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})